export function isSingleResponseMessage(response: any): response is {
    ResponseClass?: string;
    MessageText?: string;
    ResponseCode?: string;
} {
    return (response &&
        typeof response === "object" &&
        !("status" in response) && // Not a Fetch API Response
        (response.ResponseClass !== undefined ||
            response.MessageText !== undefined ||
            response.ResponseCode !== undefined));
}
